module.exports = __webpack_public_path__ + "static/image_onlineEnrollment-a4dc3f7f03f266a4ab851a6e8a5acfe8.jpg";